import { render } from "./HomeView.vue?vue&type=template&id=f2b83c22"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "@/assets/css/views/HomeView.scss?vue&type=style&index=0&lang=scss"
import "@/assets/css/components/FileUpload.scss?vue&type=style&index=1&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__